import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { chunk } from 'lodash';
import moment from 'moment';
import bem from 'helpers/bem';
import { downArrowSvg } from 'images';

const pageSize = 5;

const Icon = styled.img`
  ${props => props.up && 'transform: rotate(-180deg);'};
`;

class TimeslotGroup extends React.Component {
  static propTypes = {
    group: PropTypes.arrayOf({}).isRequired,
    selected: PropTypes.string.isRequired,
    setTimeslot: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
    };
    this.changePage = this.changePage.bind(this);
  }

  changePage(diff) {
    const page = this.state.page + diff;
    this.setState({ page });
  }

  render() {
    const { group, selected, setTimeslot } = this.props;
    const { page } = this.state;
    const chunkedTimeslots = chunk(group, pageSize);
    const showButtons = chunkedTimeslots.length > 1;
    return (
      <div>
        {showButtons && (
          <button
            className={bem('TimeslotPicker__Timeslot', {})}
            onClick={() => this.changePage(-1)}
            disabled={page === 0}
          >
            <Icon up src={downArrowSvg} />
          </button>
        )}
        {!showButtons && (
          <button className={bem('TimeslotPicker__Timeslot', { hidden: true })}>
            <Icon up src={downArrowSvg} />
          </button>
        )}
        {!!chunkedTimeslots[page] &&
          chunkedTimeslots[page].map(timeslot => (
            <button
              className={bem('TimeslotPicker__Timeslot', {
                notChecked: selected && timeslot !== selected,
                checked: timeslot === selected,
              })}
              key={timeslot}
              onClick={() => setTimeslot(timeslot)}
            >
              {moment(timeslot).format('LT')}
            </button>
          ))}
        {showButtons && (
          <button
            className={bem('TimeslotPicker__Timeslot', {})}
            onClick={() => this.changePage(1)}
            disabled={!chunkedTimeslots[page + 1]}
          >
            <Icon src={downArrowSvg} />
          </button>
        )}
        {!showButtons && (
          <button className={bem('TimeslotPicker__Timeslot', { hidden: true })}>
            <Icon up src={downArrowSvg} />
          </button>
        )}
      </div>
    );
  }
}

export default TimeslotGroup;



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/components/TimeslotPicker/TimeslotGroup.jsx